module.exports = __webpack_public_path__ + "static/img/palmyou-homepage-bg.c5ddaab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/index/palmyou-homepage-bg.jpg
// module id = HBm4
// module chunks = 4